import React, { useState, useEffect } from "react";

const ErrorBubble = ({ message }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Set a timer to hide the error after 3 seconds
    const timer = setTimeout(() => {
      setVisible(false);
    }, 3000);

    // Cleanup the timer if component unmounts early
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <div
        style={{
          opacity: visible ? 1 : 0,
          pointerEvents: visible ? "auto" : "none",
        }}
      >
        <strong>{message}</strong>
      </div>
    </div>
  );
};

export default ErrorBubble;

// TODO: implement this css to error bubble
// .errorBubble {
//   position: absolute;
//   transition: opacity 1s ease-out;
//   top: -2.5rem;
//   left: 0;
//   background-color: white;
//   color: red;
//   padding: 0.5rem 1rem;
//   border: 1px solid #e54e35;
//   border-radius: 8px;
//   font-size: 0.9rem;
//   max-width: 300px;
//   box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
//   z-index: 10;
// }